import React, { Fragment } from 'react';
import Menu from '@material-ui/core/Menu';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import useSettings from '../../hooks/useSettings';
import { MenuItem } from '@material-ui/core'; 

const useStyles = makeStyles(({ palette }) => ({
  menuButton: {
    color: palette.text.primary,
  },
}));

const ButtonMenu = (props) => {
  const {
    children,
    menuButton,
    shouldCloseOnItemClick = true,
    horizontalPosition = 'left',
    disabled,
    open: controlledOpen,
    onClose: controlledOnClose,
    anchorEl: controlledAnchorEl,
  } = props;

  const { settings } = useSettings();
  const classes = useStyles();

  const [internalAnchorEl, setInternalAnchorEl] = React.useState(null);
  const isControlled = controlledOpen !== undefined && controlledOnClose !== undefined;
  const open = isControlled ? controlledOpen : Boolean(internalAnchorEl);
  const anchorEl = isControlled ? controlledAnchorEl : internalAnchorEl;

  const handleClick = (event) => {
    if (disabled) return;
    if (!isControlled) {
      setInternalAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    if (isControlled) {
      controlledOnClose();
    } else {
      setInternalAnchorEl(null);
    }
  };

  const renderChildren = () => {
    return React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) return child;

      // Если элемент — простой MenuItem, оборачиваем его onClick
      if (child.type === MenuItem) {
        const originalOnClick = child.props.onClick;
        const newOnClick = (event) => {
          if (shouldCloseOnItemClick) {
            handleClose(); // закрываем основное меню
          }
          if (originalOnClick) {
            originalOnClick(event);
          }
        };
        return React.cloneElement(child, {
          onClick: newOnClick,
          onClose: handleClose, // на всякий случай передаём и проп
        });
      }

      // Для всех остальных (NestedMenu, кастомные компоненты) добавляем onClose
      return React.cloneElement(child, {
        onClose: handleClose,
      });
    });
  };

  return (
    <Fragment>
      <div className={classes.menuButton} onClick={handleClick}>
        {menuButton}
      </div>

      <ThemeProvider theme={settings.themes[settings.activeTheme]}>
        <Menu
          elevation={8}
          getContentAnchorEl={null}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: horizontalPosition,
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: horizontalPosition,
          }}
        >
          {renderChildren()}
        </Menu>
      </ThemeProvider>
    </Fragment>
  );
};

export default ButtonMenu;